import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Grid,
  Typography,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useStyles } from './pricing.styles'
import formatDate from '../../utils/formatDate'
import { HeroSection, RichText } from '../../components'
import { contentfulArrayToObject } from '../../utils/cms'

const PricingPage = ({ t, data = {} }) => {
  const { ContentfulPriceListBlock: priceListBlocks } = contentfulArrayToObject(
    data.feature || [],
  )
  const { hero } = data
  const styles = useStyles()

  return (
    <main>
      <HeroSection {...hero} t={t} />
      <Container maxWidth="lg">
        <Grid container className={styles.mainContainer}>
          {/* Price Sections */}
          <Grid item xs={12}>
            {priceListBlocks.map((priceListItem, priceListItemIndex) => (
              <Box
                className={styles.accordionWrapper}
                key={`price-list-block-${priceListItemIndex}`}
              >
                <Accordion className={styles.priceListContainer}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box className={styles.priceHeader}>
                      <Typography
                        variant="h3"
                        className={styles.primaryHeading}
                      >
                        {priceListItem.priceHeading}
                      </Typography>
                      <Typography
                        variant="body1"
                        className={styles.priceListSubheading}
                      >
                        {priceListItem.description}
                        &nbsp;&nbsp;●&nbsp;&nbsp;
                        {t('Last Updated at')}{' '}
                        {formatDate(priceListItem.updatedAt)}
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails className={styles.accordionDetails}>
                    {priceListItem.priceListText.raw && (
                      <Box>
                        <RichText
                          document={JSON.parse(priceListItem.priceListText.raw)}
                        />
                      </Box>
                    )}
                  </AccordionDetails>
                </Accordion>
              </Box>
            ))}
          </Grid>
        </Grid>
      </Container>
    </main>
  )
}

export default PricingPage
